<!--  -->
<template>
    <div class="site-init">
        <div v-for="(item,i) in parseInt(pcCount)" :key="i">
            <div class="site-list-item" v-if="siteType!=2  && parseInt(pcCount)>0">
                <div class="site-item-fl">
                    <div class="site-item-img">
                        <span>
                            <i class="iconfont icon-bianzu-15_2x"></i>
                        </span>
                        <p>
                            待开通
                            <el-tooltip class="item" effect="light" popper-class="site-item-tooltip" content="待开通指已购买建站服务，但网站还未开通" placement="top-start">
                                <el-button>
                                    <i class="iconfont icon-bianzubeifen"></i>
                                </el-button>
                            </el-tooltip>
                        </p>
                    </div>
                    <div class="site-item-txt">
                        <div class="site-item-title">建营销型网站，就上牛商云</div>
                        <ul>
                            <li>可视化操作</li>
                            <li>蜘蛛主动喂养</li>
                            <li>一键智能诊断</li>
                            <li>百套建站方案</li>
                        </ul>
                    </div>
                </div>
                <div class="site-item-btn" @click="openPageList('/pageList','PC')">制作PC站</div>
            </div>
        </div>
        <div v-for="(item,i) in parseInt(mcCount)" :key="i+mcCount">
            <div class="site-list-item" v-if="siteType!=1 && parseInt(mcCount) > 0">
                <div class="site-item-fl">
                    <div class="site-item-img">
                        <span>
                            <i class="iconfont icon-shouji10"></i>
                        </span>
                        <p>
                            待开通
                            <el-tooltip class="item" effect="light" popper-class="site-item-tooltip" content="待开通指已购买建站服务，但网站还未开通" placement="top-start">
                                <el-button>
                                    <i class="iconfont icon-bianzubeifen"></i>
                                </el-button>
                            </el-tooltip>
                        </p>
                    </div>
                    <div class="site-item-txt">
                        <div class="site-item-title">建营销型网站，就上牛商云</div>
                        <ul>
                            <li>可视化操作</li>
                            <li>蜘蛛主动喂养</li>
                            <li>一键智能诊断</li>
                            <li>百套建站方案</li>
                        </ul>
                    </div>
                </div>
                <div class="site-item-btn" @click="openPageList('/pageList','手机')">制作手机站</div>
            </div>
        </div>
        <div class="site-list-item site-item-experience" v-if="isExperience === 0">
            <div class="site-item-fl">
                <div class="site-item-img">
                    <span>
                        <i class="iconfont icon-bianzu-15beifen-2_2x"></i>
                    </span>
                    <p>
                        体验试用
                        <el-tooltip class="item" effect="light" popper-class="site-item-tooltip" content="每个用户有一个体验试用站点，欢迎体验最新功能和建站方案" placement="top-start">
                            <el-button>
                                <i class="iconfont icon-bianzubeifen"></i>
                            </el-button>
                        </el-tooltip>
                    </p>
                </div>
                <div class="site-item-txt">
                    <div class="site-item-title">建营销型网站，就上牛商云</div>
                    <ul>
                        <li>可视化操作</li>
                        <li>蜘蛛主动喂养</li>
                        <li>一键智能诊断</li>
                        <li>百套建站方案</li>
                    </ul>
                </div>
            </div>
            <div class="site-item-btn" @click="openPageList('/pageList')">马上体验</div>
        </div>
        <site-type-dialog v-if="showDialog" :showDialog.sync="showDialog" :tblType="tblType" @responseFn="responseFn" @closeCurModal="closeCurModal"></site-type-dialog>
    </div>
</template>

<script>
import ConsoleApi from '@/api/console.api'
import SiteTypeDialog from './SiteTypeDialog'
import { mapState, mapGetters, mapActions } from 'vuex'


export default {
    name: 'SiteListInit',
    props: {
        siteType: {
            type: Number,
            default: 0
        },
        spaceCount: {
            type: Number,
            default: 0
        },
    },
    components: { SiteTypeDialog },
    data () {
        return {
            pcCount: 0,
            mcCount: 0,
            pcNotSite: 0,
            mcNotSite: 0,
            isExperience: 1,
            showDialog: false,
            tblType: '',
            queryInfo: {}
        }
    },
    created () {
        this.siteCount()
    },
    computed: {
        ...mapGetters('user', ['userInfo']),
    },
    methods: {
        async siteCount () {
            const params = {
                userId: this.userInfo.uid
            }
            const { data } = await ConsoleApi.getSpace(params)
            if (data.isSuccess) {
                this.pcCount = data.data.PC
                this.mcCount = data.data.mobile
                this.isExperience = data.data.EXPERIENCE
                return parseInt(this.pcCount) && parseInt(this.mcCount)
            } else {
                console.log(data.message)
            }
        },
        openUrl (url, params) {
			console.log(url)
            const routeData = this.$router.resolve({ path: url, query: params })
            window.open(routeData.href, '_blank')
        },
        async openPageList (url, tblType) {
            let linkData = {
                tblType: tblType
            }
            if (tblType) {//判断是否为体验站点， 1是 0 否
                linkData.experience = 0
            } else {
                this.openUrl(url, linkData)
                return
            }
            // const params = {
            //     userId: this.userInfo.uid,
            //     suitName: '经典版'
            // }
            // const { data } = await ConsoleApi.checkResponsiveSpace(params)
            // if (data.isSuccess && data.data) {
            //     this.queryInfo = linkData
            //     this.showDialog = true
            //     this.tblType = tblType
            //     return
            // }
            this.openUrl(url, linkData)
        },// 弹框提示选择响应式建站
        responseFn () {
            let params = this.queryInfo
            params.tblType = '响应式'
            this.openUrl('/pageList', params)
        },
        // 弹框提示选择独立分开建站
        closeCurModal (data) {
            this.openUrl('/pageList', this.queryInfo)
        }
    },
}
</script>
<style lang='scss' scoped>
.site-list-item {
    height: 190px;
    border-bottom: 1px solid #c6cde6;
    display: flex;
    align-items: center;
    .site-item-fl {
        width: 554px;
        height: 90px;
        display: flex;
        ul {
            width: 190px;
            display: flex;
            flex-wrap: wrap;
        }
        li {
            width: 50%;
            padding-left: 14px;
            position: relative;
            font-size: 12px;
            line-height: 27px;
            color: #373d45;
            &:after {
                content: "";
                width: 4px;
                height: 4px;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 0;
                margin-top: -2px;
                background: #373d45;
            }
        }
    }
    .site-item-img {
        width: 90px;
        height: 90px;
        margin-right: 30px;
        padding-top: 6px;
        background: rgba(231, 236, 248, 1);
        border-radius: 4px;
        text-align: center;
        & > span i {
            font-size: 36px;
            color: #373d45;
        }
        p {
            font-size: 12px;
            line-height: 17px;
            color: #373d45;
            .el-button {
                width: 12px;
                height: 12px;
                padding: 0;
                margin-left: 4px;
                border: 0;
                background: none;
                &:hover {
                    color: #373d45;
                }
            }
            i {
                font-size: 12px;
            }
        }
    }
    .site-item-title {
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        color: #373d45;
    }
    .site-item-btn {
        width: 90px;
        height: 30px;
        background: #f1592a;
        border-radius: 2px;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        cursor: pointer;
    }
}
.site-item-experience {
    .site-item-btn {
        background: $colorA;
    }
}
</style>
